// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';
import { Moves } from '@gql/base-types';

import { Modal } from '@components/ModalComponents';
import AssignRefModalContent from './AssignRefModalContent';

// TYPES ---------------------------------------------------------------- //

interface AssignRefModalProps {
  open: boolean;
  onClose?: (output?: any) => void;
  moveInput?: Moves | null;
}

// COMPONENT ---------------------------------------------------------------- //

const AssignRefModal = ({ open, onClose, moveInput }: AssignRefModalProps) => {
  return (
    <Modal open={open}>{open && moveInput ? <AssignRefModalContent onClose={onClose} move={moveInput} /> : null}</Modal>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default AssignRefModal;
